import React from "react";
import Icon from "../Icon/icon";

const Button = ({ children, full, disabled, onClick, variant = "primary", size = "regular", iconLeft, iconRight, className }) => {
    if (!children) return null;

    return (
        <button
            type="button"
            className={`button button--${variant} button--${size} ${full ? "button--full" : ""} ${className}`}
            onClick={onClick}
            disabled={disabled}
        >
            {iconLeft && <Icon icon={iconLeft} className="button__icon button__icon--left" />}
            {children}
            {iconRight && <Icon icon={iconRight} className="button__icon button__icon--right" />}
        </button>
    );
};

export default Button;
